export const componentOptions = {
  AnchorLinks: {
    sizes: {
      minWidthMedium: {
        min: 12,
        max: 12,
      },
      minWidthLarge: {
        min: 12,
        max: 12,
      },
    },
  },
  OnlineWorkshops: {
    sizes: {
      minWidthMedium: {
        min: 6,
        max: 12,
      },
      minWidthLarge: {
        min: 4,
        max: 4,
      },
    },
  },
  EventCountdownTimer: {
    sizes: {
      minWidthMedium: {
        min: 12,
        max: 12,
      },
      minWidthLarge: {
        min: 12,
        max: 12,
      },
    },
  },
  'Top Savings for You': {
    sizes: {
      minWidthMedium: {
        min: 12,
        max: 12,
      },
      minWidthLarge: {
        min: 12,
        max: 12,
      },
    },
  },
  SpecialBuyOfTheDay: {
    sizes: {
      minWidthMedium: {
        min: 6,
        max: 4,
      },
      minWidthLarge: {
        min: 4,
        max: 4,
      },
    },
  },
  'Todays Recommendations for You': {
    sizes: {
      minWidthMedium: {
        min: 12,
        max: 12,
      },
      minWidthLarge: {
        min: 8,
        max: 12,
      },
    },
  },
  'Sponsored Products': {
    sizes: {
      minWidthMedium: {
        min: 12,
        max: 12,
      },
      minWidthLarge: {
        min: 12,
        max: 12,
      },
    },
  },
  'Recently Viewed': {
    sizes: {
      minWidthMedium: {
        min: 6,
        max: 12,
      },
      minWidthLarge: {
        min: 8,
        max: 12,
      },
    },
  },
};
